import { render, staticRenderFns } from "./supplierPortrait.vue?vue&type=template&id=c55bd41e&scoped=true&"
import script from "./supplierPortrait.vue?vue&type=script&lang=js&"
export * from "./supplierPortrait.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c55bd41e",
  null
  
)

export default component.exports